export default __webpack_public_path__ + "media/src/features/open-house-registration-my-activity/assets/noListingImage-708d56432d766e3b2e35a588496ca87a.svg";